<template>
  <b-container>
    <b-row class="justify-content-center pt-2" style="background-color: #f6f7fa;">
      <b-col id="contentPrintA5" ref="contentPrintA5" cols="5" md="10">
        <b-container class="h-100 bg-wave">
          <div class="pt-5 px-3 pb-3">
            <b-row class="mx-0">
              <b-col class="mb-1" cols="5">
                <h6 class="size16 fw-bold-800 text-dark mb-1">
                  {{ userData.name }}
                </h6>
                <h6 class="size12 fw-bold-600 text-dark text-darken-5 mb-0">
                  {{ userData.address }}<span v-if="userData.postal_code && userData.postal_code !== 'null'">, {{ userData.postal_code }}</span>
                </h6>
              </b-col>
              <b-col cols="5" offset="1" class="pl-5">
                <div class="" v-if="$route.query.type !== 'other'">
                  <h6 class="size14 fw-bold-500 text-dark mb-0 text-right" style="line-height: 20px;">
                    {{ result.date || result.payment_date || '-' }} <br>
                    <span v-if="$route.query.type === 'utang_piutang'">
                      Pelanggan : <br>
                    </span>
                    <span v-else>
                      Kepada Yth : <br>
                    </span>
                    {{ supplier.name || '-' }}
                  </h6>
                  <h6 class="size14 fw-bold-500 text-dark mb-0 text-right" v-html="supplier.address"></h6>
                </div>
              </b-col>
              <b-col cols="11" v-if="$route.query.type === 'utang_piutang'">
                <h4 class="text-center fw-bold-800 text-dark mt-3">
                  Pembayaran Piutang
                </h4>
              </b-col>
              <b-col cols="11">
                <hr>
              </b-col>
            </b-row>
            <b-row class="mx-0">
              <b-col cols="11">
                <div v-if="$route.query.type == 'supplier'">
                  <TableSupplier :items="items" />
                </div>
                <div v-if="$route.query.type == 'order'">
                  <TableOrder :items="items" />
                </div>
                <div v-if="$route.query.type == 'other'">
                  <TableOther :fields="fields" :items="items" />
                </div>
                <div v-if="$route.query.type == 'utang_piutang'">
                  <TableSale :fields="fields" :items="items" />
                </div>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </b-col>
      <b-col cols="12" lg="5" class="thermal-payment-report">
        <div style="position: absolute; left: -1000rem">
          <!-- Thermal Print -->
          <b-container id="payment-thermal-print" class="h-100 bg-wave">
            <div class="pt-md-3 px-lg-3 px-2 pb-3" style="letter-spacing: 0.3px">
              <!-- Logo -->
              <table style="width: 100%">
                <tr>
                  <td style="text-align: center;"><b-img v-if="imageLogo" :src="imageLogo" alt="logo" class="custom-img" style="margin-left: 0; width: 200px; height: auto" /></td>
                </tr>
              </table>
              <h4 class="size18 fw-bold-500 text-black mb-0 mt-2 title-struck" v-if="$route.query.type === 'utang_piutang'" style="font-weight: 900 !important; margin-top: 1.5rem !important;">
                Pembayaran Piutang
              </h4>
              <!-- Detail -->
              <b-row class="mx-0 mt-2">
                <b-col style="padding: 0" lg="12">
                  <h6 class="size10 text-black mb-1 details--font">
                    {{ userData.name  || "-" }}
                  </h6>
                  <table style="width: 100%;">
                    <tr>
                      <td style="font-size: 10px; word-break: break-word; white-space: normal; padding-right: 50px !important;">
                        {{ userData.address }}<span v-if="userData.postal_code && userData.postal_code !== 'null'">, {{ userData.postal_code }}</span>
                      </td>
                    </tr>
                  </table>
                  <h6 class="size10 text-black mb-1 details--font">
                    Tlp: {{ userData.phone }}
                  </h6>
                  <h6 class="size10 text-black mb-1 details--font">
                    <span v-if="$route.query.type === 'utang_piutang'">
                      Pelanggan : 
                    </span>
                    <span v-else>
                      Kepada Yth : 
                    </span>
                    {{ supplier.name || '-' }}
                  </h6>
                  <table style="width: 100%;">
                    <tr>
                      <td style="font-size: 10px; word-break: break-word; white-space: normal; padding-right: 50px !important;">
                        Alamat: {{ supplier.address || "-" }}
                      </td>
                    </tr>
                  </table>
                  <h6 class="size10 text-black mb-1 details--font">
                    Tanggal Pembayaran: {{ payment_date || "-" }}
                  </h6>
                  <h6 class="size10 text-black mb-1 details--font">
                    Invoice: {{ invoice_number || "-" }}
                  </h6>
                </b-col>
                <b-col style="padding: 0" lg="12">
                  <hr class="mb-25" style="border-top: 1px solid #000" />
                </b-col>
              </b-row>
              <b-row class="mx-0">
                <b-col cols="12" style="padding-left: 0px !important;">
                  <div v-if="$route.query.type === 'supplier'">
                    <TableSupplier :items="items" />
                  </div>
                  <div v-if="$route.query.type === 'order'">
                    <TableOrder :items="items" />
                  </div>
                  <div v-if="$route.query.type === 'other'">
                    <TableOther :fields="fields" :items="items" />
                  </div>
                  <div v-if="$route.query.type === 'utang_piutang'">
                    <TableSale :fields="fieldsPrint" :items="items" />
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-container>
          <!-- Dot Matrix -->
          <b-container id="payment-thermal-print-matrix" class="h-100 bg-wave">
            <div class="pt-md-3 px-lg-3 px-2 pb-3" style="letter-spacing: 0.3px">
              <!-- Logo -->
              <table style="width: 100%">
                <tr>
                  <td style="text-align: center;"><b-img v-if="imageLogo" :src="imageLogo" alt="logo" class="custom-img" style="margin-left: 0; width: 200px; height: auto" /></td>
                </tr>
              </table>
              <h4 class="size18 fw-bold-500 text-black mb-0 mt-2 title-struck" v-if="$route.query.type === 'utang_piutang'" style="font-weight: 900 !important; margin-top: 1.5rem !important;">
                Pembayaran Piutang
              </h4>
              <!-- Detail -->
              <b-row class="mx-0 mt-2">
                <b-col style="padding: 0" lg="12">
                  <h6 class="size10 text-black mb-1 details--font">
                    {{ userData.name  || "-" }}
                  </h6>
                  <table style="width: 100%;">
                    <tr>
                      <td style="font-size: 10px; word-break: break-word; white-space: normal; padding-right: 50px !important;">
                        {{ userData.address }}<span v-if="userData.postal_code && userData.postal_code !== 'null'">, {{ userData.postal_code }}</span>
                      </td>
                    </tr>
                  </table>
                  <h6 class="size10 text-black mb-1 details--font">
                    Tlp: {{ userData.phone }}
                  </h6>
                  <h6 class="size10 text-black mb-1 details--font">
                    <span v-if="$route.query.type === 'utang_piutang'">
                      Pelanggan : 
                    </span>
                    <span v-else>
                      Kepada Yth : 
                    </span>
                    {{ supplier.name || '-' }}
                  </h6>
                  <table style="width: 100%;">
                    <tr>
                      <td style="font-size: 10px; word-break: break-word; white-space: normal; padding-right: 50px !important;">
                        Alamat: {{ supplier.address || "-" }}
                      </td>
                    </tr>
                  </table>
                  <h6 class="size10 text-black mb-1 details--font">
                    Tanggal Pembayaran: {{ payment_date || "-" }}
                  </h6>
                  <h6 class="size10 text-black mb-1 details--font">
                    Invoice: {{ invoice_number || "-" }}
                  </h6>
                </b-col>
                <b-col style="padding: 0" lg="12">
                  <hr class="mb-25" style="border-top: 1px solid #000" />
                </b-col>
              </b-row>
              <b-row class="mx-0">
                <b-col cols="12" style="padding-left: 0px !important;">
                  <div v-if="$route.query.type === 'supplier'">
                    <TableSupplier :items="items" />
                  </div>
                  <div v-if="$route.query.type === 'order'">
                    <TableOrder :items="items" />
                  </div>
                  <div v-if="$route.query.type === 'other'">
                    <TableOther :fields="fields" :items="items" />
                  </div>
                  <div v-if="$route.query.type === 'utang_piutang'">
                    <TableSale :fields="fieldsPrint" :items="items" />
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-container>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BContainer, BRow, BCol, BImg
} from 'bootstrap-vue'
import TableSupplier from '@/components/Payout/PaymentReport/TableSupplier.vue'
import TableOther from '@/components/Payout/PaymentReport/TableOther.vue'
import TableOrder from '@/components/Payout/PaymentReport/TableOrder.vue'
import TableSale from '@/components/Payout/PaymentReport/TableSale.vue'

export default {
  components: {
    BRow,
    BCol,
    BContainer,
    BImg,

    TableSupplier,
    TableOther,
    TableOrder,
    TableSale,
  },
  props: {
    result: {
      type: Object,
    },
  },
  data() {
    return {
      fields: [],
      fieldsPrint: [],
      items: [],
      supplier: {},
      imageLogo: null,
      userData: JSON.parse(localStorage.getItem('userData')).branch,
      payment_date: '',
      invoice_number: ''
    }
  },
  watch: {
    result: {
      handler(value) {
        if (this.$route.query.type === 'supplier') {
          this.supplier = value.supplier
          this.fields = ['po_so_id', 'delivery_numbers', 'invoice_number', 'factur_number', 'amount', 'metode_bayar']
          for (let index = 0; index < value.payments.length; index++) {
            const element = value.payments[index]
            this.items.push({
              po_so_id: element.po_so_id,
              delivery_numbers: element.delivery_numbers,
              invoice_number: element.invoice_number,
              factur_number: element.factur_number,
              amount: element.amount,
              vouchers: element.vouchers,
            })
          }
        }
        if (this.$route.query.type === 'order') {
          this.supplier = value.customer
          this.fields = ['po_so_id', 'delivery_numbers', 'invoice_number', 'factur_number', 'amount', 'metode_bayar']
          for (let index = 0; index < value.payments.length; index++) {
            const element = value.payments[index]
            this.items.push({
              po_so_id: element.po_so_id,
              delivery_numbers: element.delivery_numbers,
              invoice_number: element.invoice_number,
              factur_number: element.factur_number,
              amount: element.amount,
            })
          }
        }
        if (this.$route.query.type === 'other') {
          this.fields = [
            {
              label: 'Tanggal',
              key: 'date',
            },
            {
              label: 'Tipe',
              key: 'tipe_pembayaran',
            },
            {
              label: 'Jenis',
              key: 'jenis_pembayaran',
            },
            {
              label: 'Detail',
              key: 'detail',
            },
            {
              label: 'Penerima',
              key: 'receiver',
            },
            {
              label: 'No. Invoice/SPT',
              key: 'invoice_number_spt',
            },
            {
              label: 'Nilai',
              key: 'amount',
            },
            {
              label: 'Metode Pembayaran',
              key: 'payment_method',
            },
            // {
            //   label: 'Bukti Bayaran',
            //   key: 'file_attachment',
            // },
          ]
          this.supplier = value
          this.items = [{
            date: value.date,
            tipe_pembayaran: value.tipe_pembayaran,
            jenis_pembayaran: value.jenis_pembayaran,
            detail: value.detail,
            receiver: value.receiver,
            invoice_number_spt: value.invoice_number_spt,
            amount: value.amount,
            payment_method: value.payment_method,
            // file_attachment: value.file_attachment,
          }]
        }
        if (this.$route.query.type === 'utang_piutang') {
          const isValid = this.hasNoImageExtension(value?.photo_url)
          this.imageLogo = isValid ? value.photo_url : ''
          this.supplier = value.customer
          this.payment_date = value.payment_date
          this.invoice_number = value.invoice_number

          this.fields = ['invoice_number', 'jumlah', 'sisa', 'keterangan']
          this.fieldsPrint = [
            {
              key: 'jumlah',
              label: 'Jumlah',
            },
            {
              key: 'sisa',
              label: 'Sisa',
            },
            {
              key: 'keterangan',
              label: 'Keterangan',
            }
          ];

          this.items = [{
            invoice_number: value.invoice_number,
            jumlah: value.amount,
            sisa: value.unpaid,
            keterangan: value.unpaid,
          }]
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getData()
    const isValid = this.hasNoImageExtension(this.userData?.photo_url)
    this.imageLogo = isValid ? this.userData?.photo_url : ''
    // console.log(JSON.parse(localStorage.getItem('userData')))
  },
  methods: {
    getData() {
      if (this.$route.query.type === 'supplier') {
        this.supplier = this.result.supplier
        this.fields = ['po_so_id', 'delivery_numbers', 'invoice_number', 'factur_number', 'amount', 'metode_bayar']
        for (let index = 0; index < this.result.payments.length; index++) {
          const element = this.result.payments[index]
          this.items.push({
            po_so_id: element.po_so_id,
            delivery_numbers: element.delivery_numbers,
            invoice_number: element.invoice_number,
            factur_number: element.factur_number,
            amount: element.amount,
            vouchers: element.vouchers,
          })
        }
      }
      if (this.$route.query.type === 'order') {
        this.supplier = this.result.customer
        this.fields = ['po_so_id', 'delivery_numbers', 'invoice_number', 'factur_number', 'amount', 'metode_bayar']
        for (let index = 0; index < this.result.payments.length; index++) {
          const element = this.result.payments[index]
          this.items.push({
            po_so_id: element.po_so_id,
            delivery_numbers: element.delivery_numbers,
            invoice_number: element.invoice_number,
            factur_number: element.factur_number,
            amount: element.amount,
          })
        }
      }
      if (this.$route.query.type === 'other') {
        this.fields = [
          {
            label: 'Tanggal',
            key: 'date',
          },
          {
            label: 'Tipe',
            key: 'tipe_pembayaran',
          },
          {
            label: 'Jenis',
            key: 'jenis_pembayaran',
          },
          {
            label: 'Detail',
            key: 'detail',
          },
          {
            label: 'Penerima',
            key: 'receiver',
          },
          {
            label: 'No. Invoice/SPT',
            key: 'invoice_number_spt',
          },
          {
            label: 'Nilai',
            key: 'amount',
          },
          {
            label: 'Metode Pembayaran',
            key: 'payment_method',
          },
          // {
          //   label: 'Bukti Bayaran',
          //   key: 'file_attachment',
          // },
        ]
        this.supplier = this.result
        this.items = [{
          date: this.result.date,
          tipe_pembayaran: this.result.tipe_pembayaran,
          jenis_pembayaran: this.result.jenis_pembayaran,
          detail: this.result.detail,
          receiver: this.result.receiver,
          invoice_number_spt: this.result.invoice_number_spt,
          amount: this.result.amount,
          payment_method: this.result.payment_method,
          // file_attachment: this.result.file_attachment,
        }]
      }
      if (this.$route.query.type === 'utang_piutang') {
        this.supplier = this.result.customer
        this.fields = ['invoice_number', 'jumlah', 'sisa', 'keterangan'];
        this.fieldsPrint = [
          {
            key: 'jumlah',
            label: 'Jumlah',
          },
          {
            key: 'sisa',
            label: 'Sisa',
          },
          {
            key: 'keterangan',
            label: 'Keterangan',
          }
        ];
        this.payment_date = this.result.payment_date
        this.invoice_number = this.result.invoice_number
        this.items = [{
          invoice_number: this.result.invoice_number,
          jumlah: this.result.amount,
          sisa: this.result.unpaid,
          keterangan: this.result.unpaid,
        }]
      }
    },
    hasNoImageExtension(url) {
      const validExtensions = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i;
      return validExtensions.test(url);
    },
  }
}
</script>

<style lang="scss" scoped>
.bg-wave {
  background-color: #FFFFFF;
  border-radius: 24px;
}
</style>

<style lang="scss">
@import '@/assets/scss/variables/_variables.scss';

.table:not(.table-dark):not(.table-light) thead:not(.thead-dark) th {
  background-color: transparent;
  border-bottom: none;
}

.thermal-payment-report {
  display: none;
}

.table {
  thead {
    tr {
      th {
        border-bottom: 1px solid #ebe9f1;
        background-color: transparent;
        border-top: none;
        padding: .5rem 0;
        color: #7A7F94;
        font-weight: 500;
        text-transform: capitalize;
        font-size: 12px;
      }
    }
  }

  tbody {
    tr {
      td {
        border-top: none;
        color: $dark;
        font-size: 12px;
        font-weight: 600;
        padding: 1.5rem 0;
        border-bottom: 1px solid #ebe9f1;
      }
    }
  }
}
</style>
